module.exports = __webpack_public_path__ + "img/avatar7.cb57a191.png";